import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import type React from 'react';

import { ControlesLinha, ProcessoInput } from '../../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from '../relatorio-civel-step-props';

type Props = RelatorioCivelStepProps & {
  section: 'outrasManifestacoes' | 'ciencia';
  novoProcesso: string;
  setNovoProcesso: React.Dispatch<React.SetStateAction<string>>;
};

export default function StepCriminalProcessoLista(props: Props) {
  const {
    section,
    novoProcesso,
    setNovoProcesso,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  const processos = formData[section].processos;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcesso}
                onChange={setNovoProcesso}
                onAdicionar={() => adicionarProcesso(section, novoProcesso, setNovoProcesso)}
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}
      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas[section]}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, [section]: Math.max(1, prev[section] - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, [section]: Math.min(50, prev[section] + 1) }))
          }
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, [section]: value }))}
          onAdicionar={() => adicionarMultiplasLinhas(section)}
          totalLabel="Total de Processos"
          totalCount={processos.length}
        />
      )}
      {renderTabelaProcessos(section, processos)}
    </Fragment>
  );
}
